import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable react/jsx-props-no-spreading */
import { BackdropLoader, toast } from '@livable/saas-react-components';
import { Button, Paper, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AddNewMemberModal } from 'src/components/property/AddNewMemberModal';
import { TEAM_MEMBER_ROLES_BY_NAMES, USER_SETTINGS_KEYS } from 'src/constants/userSetting';
import { useStore } from 'src/stores';
import { PROPERTY_STEPS } from 'src/constants/property';
import TeamMemberBlock from './TeamMemberBlock';
import useStyles from './styles';
const BUILDING_CONTACT_TYPES = {
  building: 'Building',
  utility: 'Utility'
};
export const PropertyContactInformation = observer(_ref => {
  let _ref$handleStep = _ref.handleStep,
    handleStep = _ref$handleStep === void 0 ? () => {} : _ref$handleStep,
    editMode = _ref.editMode,
    mutablePropertyId = _ref.mutablePropertyId,
    notCompletedPropertyId = _ref.notCompletedPropertyId,
    registerActionBack = _ref.registerActionBack,
    registerActionNext = _ref.registerActionNext;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    contactsToUpdate = _useState2[0],
    setContactsToUpdate = _useState2[1];
  const _useState3 = useState(store.addNewProperty.contactInformation.selectBuildingContacts.length ? 'someone' : 'me'),
    _useState4 = _slicedToArray(_useState3, 2),
    buildingContact = _useState4[0],
    setBuildingContact = _useState4[1];
  const handleBuildingContactChange = (e, value) => {
    if (value) setBuildingContact(value);
  };
  const _useState5 = useState(store.addNewProperty.contactInformation.selectUtilitiesContacts.length ? 'someone' : 'same'),
    _useState6 = _slicedToArray(_useState5, 2),
    utilityContact = _useState6[0],
    setUtilityContact = _useState6[1];
  const handleUtilityContactChange = (e, value) => {
    if (value) setUtilityContact(value);
  };
  const handleSubmitForm = async () => {
    const utilityData = [];
    const buildingData = [];
    const contactsToUpdateList = [...contactsToUpdate];
    const currentPropertyId = mutablePropertyId ? mutablePropertyId : notCompletedPropertyId ? notCompletedPropertyId : localStorage.getItem('livable_property_id');
    const data = {
      propertyId: currentPropertyId,
      data: {
        toCreate: [],
        toDelete: []
      }
    };
    if (buildingContact === 'me' || buildingContact !== 'me' && store.addNewProperty.contactInformation.selectBuildingContacts.length === 0) {
      store.addNewProperty.contactInformation.clearSelectedBuildingContacts();
      const viewerTeamMemberId = store.addNewProperty.contactInformation.teammembers.find(contactItem => {
        return contactItem.accountId === store.account.userProfile.id;
      });
      if (!(viewerTeamMemberId !== null && viewerTeamMemberId !== void 0 && viewerTeamMemberId.id) && (store.account.userProfile.isUserAdmin || store.account.userProfile.isUserSuperAdmin)) {
        toast('error', {
          body: ['Select team members']
        });
        return;
      }
      buildingData.push({
        contactType: 'Building',
        teamMemberId: viewerTeamMemberId.id
      });
    } else {
      store.addNewProperty.contactInformation.selectBuildingContacts.map(item => {
        buildingData.push({
          contactType: 'Building',
          teamMemberId: item.id
        });
      });
    }
    if (utilityContact === 'same' || utilityContact !== 'same' && store.addNewProperty.contactInformation.selectUtilitiesContacts.length === 0) {
      store.addNewProperty.contactInformation.clearSelectedUtilitiesContacts();
      buildingData.map(item => {
        utilityData.push({
          contactType: 'Utility',
          teamMemberId: item.teamMemberId
        });
      });
    } else {
      store.addNewProperty.contactInformation.selectUtilitiesContacts.map(item => {
        utilityData.push({
          contactType: 'Utility',
          teamMemberId: item.id
        });
      });
    }
    if (contactsToUpdateList.length === 0) {
      data.data.toCreate = [...buildingData, ...utilityData];
    } else {
      buildingData.map(item => {
        const coincidenceIndex = contactsToUpdateList.findIndex(contactItem => contactItem.teamMemberId === item.teamMemberId && contactItem.contactType === BUILDING_CONTACT_TYPES.building);
        if (coincidenceIndex !== -1) {
          contactsToUpdateList.splice(coincidenceIndex, 1);
        } else {
          data.data.toCreate.push(item);
        }
      });
      utilityData.map(item => {
        const coincidenceIndex = contactsToUpdateList.findIndex(contactItem => contactItem.teamMemberId === item.teamMemberId && contactItem.contactType === BUILDING_CONTACT_TYPES.utility);
        if (coincidenceIndex !== -1) {
          contactsToUpdateList.splice(coincidenceIndex, 1);
        } else {
          data.data.toCreate.push(item);
        }
      });
    }
    contactsToUpdateList.map(item => {
      if (item.contactType === BUILDING_CONTACT_TYPES.building) {
        data.data.toDelete.push({
          contactType: 'Building',
          teamMemberId: item.teamMemberId
        });
      } else {
        data.data.toDelete.push({
          contactType: 'Utility',
          teamMemberId: item.teamMemberId
        });
      }
    });
    const resp = await store.properties.updatePropertysContactsAsync.run(data);
    if (resp && resp.isSuccessful) {
      if (!mutablePropertyId) {
        await store.properties.updatePropertySetupProgressAsync.run({
          propertyId: currentPropertyId,
          propertySetupStep: Object.keys(PROPERTY_STEPS).find(key => PROPERTY_STEPS[key] === PROPERTY_STEPS.ContactInformation)
        });
        store.addNewProperty.changeCompletedStep(PROPERTY_STEPS.PayoutDetails);
        handleStep(PROPERTY_STEPS.PayoutDetails)();
      } else {
        const updatedContacts = await store.properties.getPropertysContactsAsync.run({
          propertyId: currentPropertyId
        });
        setContactsToUpdate(updatedContacts.response);
      }
      if (mutablePropertyId) {
        toast('success', {
          body: ['Successfully saved']
        });
      }
    }
  };
  useEffect(() => {
    const getCompanyTeamMembers = async data => {
      const resp = await store.teamMembers.getCompanyTeamMembersAsync.run(data);
      return resp;
    };
    const getProperty = async data => {
      const resp = await store.properties.getPropertyAsync.run(data);
      return resp;
    };
    const getPropertysContacts = async data => {
      const resp = await store.properties.getPropertysContactsAsync.run(data);
      return resp;
    };
    getCompanyTeamMembers({
      companyId: localStorage.getItem(USER_SETTINGS_KEYS.company)
    }).then(async resp => {
      if (!resp) {
        return;
      }
      await store.account.getProfileAsync.run(false);
      const currentPropertyId = mutablePropertyId ? mutablePropertyId : notCompletedPropertyId ? notCompletedPropertyId : localStorage.getItem('livable_property_id');
      await getProperty({
        propertyId: currentPropertyId
      });
      const contacts = await getPropertysContacts({
        propertyId: currentPropertyId
      });
      setContactsToUpdate(contacts.response);
      if (mutablePropertyId) {
        store.addNewProperty.contactInformation.initAfterLoadState();
      }
      setBuildingContact(store.addNewProperty.contactInformation.selectBuildingContacts.length ? 'someone' : 'me');
      if (store.account.userProfile.isUserAdmin || store.account.userProfile.isUserSuperAdmin) {
        setBuildingContact('someone');
      }
      setUtilityContact(store.addNewProperty.contactInformation.selectUtilitiesContacts.length ? 'someone' : 'same');
    });
    return () => {
      if (mutablePropertyId) {
        store.addNewProperty.contactInformation.resetContactInformation();
      }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (registerActionBack !== undefined) registerActionBack(() => {
      handleStep(PROPERTY_STEPS.PropertyInformation)();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registerActionBack]);
  useEffect(() => {
    if (registerActionNext !== undefined) registerActionNext(() => {
      handleSubmitForm();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registerActionNext]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Paper, {
    variant: "formWrapper"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, t('add_new_property_flow.contact_information')), /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    className: classes.sectionTitle
  }, t('add_new_property_flow.who_is_primary_building_contact'))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    value: buildingContact,
    onChange: handleBuildingContactChange,
    exclusive: true
  }, !(store.account.userProfile.isUserAdmin || store.account.userProfile.isUserSuperAdmin) && /*#__PURE__*/React.createElement(ToggleButton, {
    value: "me"
  }, t('general.me')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "someone"
  }, t('general.someone_else')))), buildingContact === 'someone' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.teamsTable
  }, store.addNewProperty.contactInformation.selectBuildingContacts.map(contact => /*#__PURE__*/React.createElement(TeamMemberBlock, {
    id: contact.id,
    key: contact.id,
    type: 'building',
    contactRole: t(TEAM_MEMBER_ROLES_BY_NAMES[contact.userRole]),
    contactName: "".concat(contact.firstName, " ").concat(contact.lastName),
    contactEmail: contact.email,
    status: contact.emailConfirmed ? 'active' : 'pending'
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(AddNewMemberModal, {
    memberType: 'building'
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.who_is_primary_utilities_contact'))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    onChange: handleUtilityContactChange,
    value: utilityContact,
    exclusive: true
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "same"
  }, t('add_new_property_flow.same_as_primary')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "someone"
  }, t('general.someone_else')))), utilityContact === 'someone' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.teamsTable
  }, store.addNewProperty.contactInformation.selectUtilitiesContacts.map(contact => /*#__PURE__*/React.createElement(TeamMemberBlock, {
    id: contact.id,
    key: contact.id,
    type: 'utilities',
    contactRole: t(TEAM_MEMBER_ROLES_BY_NAMES[contact.userRole]),
    contactName: "".concat(contact.firstName, " ").concat(contact.lastName),
    contactEmail: contact.email,
    status: contact.emailConfirmed ? 'active' : 'pending'
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(AddNewMemberModal, {
    memberType: 'utilities'
  }))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.account.getProfileAsync.inProgress || store.properties.getPropertyAsync.inProgress || store.properties.getPropertysContactsAsync.inProgress || store.teamMembers.getCompanyTeamMembersAsync.inProgress || store.properties.updatePropertysContactsAsync.inProgress || store.properties.updatePropertySetupProgressAsync.inProgress
  })), !editMode && registerActionBack === undefined && registerActionNext === undefined && /*#__PURE__*/React.createElement("div", {
    className: classes.pageFooter
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleStep(PROPERTY_STEPS.PropertyInformation),
    variant: "text",
    disabled: store.account.getProfileAsync.inProgress || store.properties.getPropertyAsync.inProgress || store.properties.getPropertysContactsAsync.inProgress || store.teamMembers.getCompanyTeamMembersAsync.inProgress || store.properties.updatePropertysContactsAsync.inProgress || store.properties.updatePropertySetupProgressAsync.inProgress,
    'custom-attribute': '97-property-contact-information'
  }, t('buttons.back'), ": ", t('add_new_property_flow.property_information')), /*#__PURE__*/React.createElement(Button, {
    onClick: handleSubmitForm,
    variant: "priority",
    disabled: store.account.getProfileAsync.inProgress || store.properties.getPropertyAsync.inProgress || store.properties.getPropertysContactsAsync.inProgress || store.teamMembers.getCompanyTeamMembersAsync.inProgress || store.properties.updatePropertysContactsAsync.inProgress || store.properties.updatePropertySetupProgressAsync.inProgress,
    'custom-attribute': '98-property-contact-information'
  }, t('general.next'), ": ", t('add_new_property_flow.fee_structure'))), editMode && /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleSubmitForm,
    variant: "priority",
    disabled: store.account.getProfileAsync.inProgress || store.properties.getPropertyAsync.inProgress || store.properties.getPropertysContactsAsync.inProgress || store.teamMembers.getCompanyTeamMembersAsync.inProgress || store.properties.updatePropertysContactsAsync.inProgress || store.properties.updatePropertySetupProgressAsync.inProgress,
    'custom-attribute': '99-property-contact-information'
  }, t('buttons.save'))));
});
PropertyContactInformation.propTypes = {
  handleStep: PropTypes.func
};